import React, {Component}               from 'react';
import PropTypes                        from 'prop-types';
import SubmitInput                      from '../Fields/SubmitInput';
import ButtonInput                      from '../Fields/ButtonInput';
import CheckboxInput                    from '../Fields/CheckboxInput';
import HeaderSteps                      from '../Fragments/HeaderSteps';
import SaveForLaterModal                from '../Fragments/SaveForLaterModal';
import FinancialRefereeSummaryWidget    from '../Fragments/FinancialRefereeSummaryWidget';
import SummaryWidgetEntity              from '../Fragments/SummaryWidgetEntity';
import { browserHistory }               from 'react-router';
import FullPageSpinner                  from '../Fragments/FullPageSpinner';

let Quote =  require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');
let Config = require('Config');

class Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantNumber: 1,
            isTenantDetailsVisible: false,
            isLandlordDetailsVisible: false,
            employers: 1,
            isFullPageSpinnerActive: false,
            uploadedFiles: [],
        };
    }

    componentWillMount() {
        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if (this.props.params.linkref) {
            if (uuidFormat.test(this.props.params.linkref)) {
                // Invalid linkref = error page
                browserHistory.push('/error/no-auth');
            }

            // if we have a linkref, load in the data before mounting the component
            HttpService.getRetrieveApplication(this.props.params.linkref);
        }

        if (!window.uornorb(window.localStorage.getItem('hasCompletedBankValidation'))) {
            let val = (window.localStorage.getItem('hasCompletedBankValidation') === 'true');
            Quote.setByPath('BaseIndividualApplication.hasCompletedBankValidation', val);
        }
    }

    componentDidMount() {
        //we pull it out as we edit it below
        let applicationChunk = JSON.parse(window.localStorage.getItem('BaseIndividualApplication'));

        // we gotta massage data for financial referees onto base individual application
        // and also their own applicantIncomeAmounts
        if (applicationChunk.financialReferees) {
            if (applicationChunk.financialReferees.length > 0) {
                let financialReferees = [];
                let totalIncome = 0;

                applicationChunk.financialReferees.map(fr => {
                    if (window.uorn(fr.applicantAnnualIncome)) {
                        fr.applicantAnnualIncome = 0;
                    }

                    if (window.uorn(fr.applicantAnnualOvertime)) {
                        fr.applicantAnnualOvertime = 0;
                    }

                    let income = parseInt(fr.applicantAnnualIncome);
                    income += (parseInt(fr.applicantAnnualOvertime) / 2);
                    totalIncome += income;
                    fr.applicantAnnualIncome = income;
                    financialReferees.push(fr);
                });

                applicationChunk.financialReferees = financialReferees;
                applicationChunk.grossIncome = totalIncome;
                Quote.set('grossIncome', totalIncome, 'BaseIndividualApplication');
            } else {
                // No referees at all, but also not Xpress = 0 income
                if (Quote.getByPath('BaseIndividualApplication.product.productId') !== 11) {
                    Quote.set('grossIncome', 0, 'BaseIndividualApplication');
                }
            }
        }

        if (Quote.getByPath('BaseIndividualApplication.productId') === 11) {
            Quote.deleteByPath('BaseIndividualApplication.financialReferees');
        }

        // Nullify applicationId to prevent any IRIS conflicts.
        Quote.set('applicationId', null, 'BaseIndividualApplication');

        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    forceTenantDetails(e) {
        e.preventDefault();
        this.setState({ isTenantDetailsVisible: true });
    }

    forceHideTenantDetails(e) {
        e.preventDefault();
        this.setState({ isTenantDetailsVisible: false });
    }

    /**
     * Toggle the extended visibility state of the tenants details summary pod
     * and scrolls the user's viewport to that position.
     *
     * @param e
     * @returns {Promise.<TResult>}
     */
    toggleTenantDetails(e) {
        e.preventDefault();

        return new Promise((resolve) => {
            resolve(this.setState({ isTenantDetailsVisible: this.state.isTenantDetailsVisible === false ? true : false }));
        }).then(() => {
            $('html, body').animate({
                scrollTop: $('#tenantDetails').offset().top - $('header.site-header').height()
            }, 1000);
        });
    }

    /**
     * Toggle the extended visibility state of the letting referee details
     * summary pod and scrolls the user's viewport to that position.
     *
     * @param e
     * @returns {Promise.<TResult>}
     */
    toggleLandlordDetails(e) {
        e.preventDefault();

        return new Promise((resolve) => {
            resolve(this.setState({ isLandlordDetailsVisible: this.state.isLandlordDetailsVisible === false ? true : false }));
        }).then(() => {
            $('html, body').animate({
                scrollTop: $('#lettingReferee').offset().top - $('header.site-header').height()
            }, 1000);
        });
    }

    /**
     * Toggles the checked state of a checkbox component within a
     * pseudo-selector. I.e. if you want a div element to be clickable to toggle
     * a checkbox contained within, this would be the way to do it.
     *
     * @param e
     */
    toggleCheckedState(e) {
        document.getElementById(e).click();
    }

    fileUploaded(file) {
        // use the file to print out a filename somewhere
        let uploadedFiles = this.state.uploadedFiles.concat([file]);
        this.setState({ uploadedFiles });
    }

    manualStepProgression() {
        window.localStorage.setItem('retryCounter', 0);
        this.setState({ isFullPageSpinnerActive: true });

        HttpService.applicationPutApplicationAndSubmit()
        .then(() => {
            window.localStorage.removeItem('validationError');
            browserHistory.push('/application/submitted');
        })
        .catch((invalidData) => {
            window.localStorage.setItem('validationError', JSON.stringify(invalidData));
            browserHistory.push('/error/applicant-validation');
        });
    }

    closeModals(e) {
        e.preventDefault();
        this.setState({
            isTermsModalVisible: false,
            isPhonePostModalVisible: false,
        });
    }

    render() {
        const lettingReferee = Quote.getByPath('BaseIndividualApplication.lettingReferee');
        const tenant = Quote.getChunk('BaseIndividualApplication');

        // get addresses
        let FaCross = require('react-icons/lib/fa/close');
        let addresses = Quote.getLocalStorageAddresses();
        let addressesWidgets = [];
        let totalMonths = 0;

        addresses.map((a, i) => {
            totalMonths += parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.' + i + '.durationMonths'));
            addressesWidgets.push(
                <div key={i}>
                    <SummaryWidgetEntity
                        fieldName={'addressHistoryAddress' + i}
                        localStorageChunk={'BaseIndividualApplication.addressHistories.' + i}
                        localStorageKey={'address'}
                        fieldType="address"
                        label={i === 0 ? 'Current address' : 'Previous address ' + String(i)}
                        addressOptions={{
                            canHaveManualEntry: false,
                            canBeForeign: true,
                            pafLookup: true,
                        }}
                        cancelable={true}
                    />
                    <SummaryWidgetEntity
                        fieldName={'addressHistoryPeriod' + i}
                        localStorageChunk={'BaseIndividualApplication.addressHistories.' + i}
                        localStorageKey={'durationMonths'}
                        dataValidation="duration_months_tenancy"
                        fieldType="number"
                        label={'Time at this address'}
                        labelAffix="months"
                        minimumConstraint={1}
                    />
                </div>
            );
        });

        window.localStorage.setItem('totalMonths', totalMonths);

        let lettingRefereeTitle = null;
        let lettingRefereePaymentFrequency = null;

        if (lettingReferee !== null && typeof lettingReferee !== 'undefined') {
            switch (lettingReferee.type) {
                case 1 :
                    lettingRefereeTitle = "Letting Agent";
                    break;
                case 2 :
                    lettingRefereeTitle = "Solicitor";
                    break;
                case 3 :
                    lettingRefereeTitle = "Managing Agent";
                    break;
                case 4 :
                    lettingRefereeTitle = "Landlord";
                    break;
            }

            switch (lettingReferee.paymentFrequency) {
                case 1 :
                    lettingRefereePaymentFrequency = "Weekly";
                    break;
                case 2 :
                    lettingRefereePaymentFrequency = "Four Weekly";
                    break;
                case 3 :
                    lettingRefereePaymentFrequency = "Monthly";
                    break;
                case 4 :
                    lettingRefereePaymentFrequency = "All in One";
                    break;
                case 5 :
                    lettingRefereePaymentFrequency = "Other";
                    break;
            }
        }

        const financialReferees = [];
        // Only show financial referees if they are 'proper' financial referees.
        // On Xpress, its a transitory data store.
        if (Quote.getByPath('BaseIndividualApplication.product.productId') !== 11) {
            for (let i = 0; i < 3; i++) {
                let fr = Quote.getByPath('BaseIndividualApplication', 'financialReferees.' + String(i));
                if (fr !== null && fr !== undefined) {
                    financialReferees.push(
                        <FinancialRefereeSummaryWidget
                            key={i}
                            financialRefereeObject={fr}
                            financialRefereeNumber={i + 1}
                        />
                    );
                }
            }
        }

        let fileNumber = 0;
        let files = JSON.parse(window.localStorage.getItem('GlobalFileList'));
        if( ! window.uorn(files)) {
            files.map(() => {
                fileNumber = fileNumber + 1;
            });
        }

        let isPhoneAndPostChecked = true;
        if (Quote.getByPath('BaseIndividualApplication.canContactApplicantByPhoneAndPost') === false) {
            isPhoneAndPostChecked = false;
        }

        return(
            <div>
                <HeaderSteps current={6} />

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                    header={"Uploading Files"}
                    numberOfUploads={fileNumber}
                    messages={this.state.uploadedFiles.map(file => {
                        return file.name + " has been uploaded";
                    })}
                />

                <question-row class="header-row">
                    <h1>Summary</h1>
                    <p>This is the last step. Please review the information you have provided before submitting the application for referencing. You can expand each section to see a summary of all of the details you entered by selecting 'view all details'. You can also amend details in each section by clicking the edit buttons.</p>
                </question-row>

                <div className="summary-container">
                    <div id="tenantDetails" className="summary-widget" style={this.state.isTenantDetailsVisible === true ? {width: '100%'} : null}>
                        <section className="pod">
                            <header className="header">
                                <h3>Your details</h3>
                            </header>
                            <div className="content">
                                {tenant.title ?
                                    <SummaryWidgetEntity
                                        fieldName="applicationTitle"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="title"
                                        fieldType={'text'}
                                        label="Title"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.firstName ?
                                    <SummaryWidgetEntity
                                        fieldName="firstName"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="firstName"
                                        fieldType={'text'}
                                        label="First name"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.middleName ?
                                    <SummaryWidgetEntity
                                        fieldName="middleName"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="middleName"
                                        fieldType={'text'}
                                        label="Middle name"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.lastName ?
                                    <SummaryWidgetEntity
                                        fieldName="lastName"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="lastName"
                                        fieldType={'text'}
                                        label="Last name"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.otherName ?
                                    <SummaryWidgetEntity
                                        fieldName="otherName"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="otherName"
                                        fieldType={'text'}
                                        label="Other name/s"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.email ?
                                    <SummaryWidgetEntity
                                        fieldName="tenantEmail"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="email"
                                        fieldType={'email'}
                                        label="Email"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {tenant.mobile ?
                                    <SummaryWidgetEntity
                                        fieldName="tenantMobile"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="mobile"
                                        fieldType={'number'}
                                        label="Mobile"
                                        callbackFunction={this.forceTenantDetails.bind(this)}
                                    />
                                : null}

                                {this.state.isTenantDetailsVisible ?
                                    <div>
                                        {tenant.phone ?
                                            <SummaryWidgetEntity
                                                fieldName="tenantPhone"
                                                localStorageChunk="BaseIndividualApplication"
                                                localStorageKey="phone"
                                                fieldType={'text'}
                                                maxLength={11}
                                                label="Phone"
                                                callbackFunction={this.forceTenantDetails.bind(this)}
                                            />
                                        : null}

                                        {tenant.birthDate ?
                                            <SummaryWidgetEntity
                                                fieldName="birthDate"
                                                localStorageChunk="BaseIndividualApplication"
                                                localStorageKey="birthDate"
                                                fieldType={'date'}
                                                subType={'dob'}
                                                label="Date of birth"
                                                callbackFunction={this.forceTenantDetails.bind(this)}
                                            />
                                        : null}

                                        <h4>Your address history</h4>
                                        {/* todo: address entries should load in a modal - too many potential fields to load in-line */}
                                        {addressesWidgets}
                                    </div>
                                : null}
                            </div>
                            <footer className="footer">
                                {! this.state.isTenantDetailsVisible ?
                                    <a href="#" className="primary-colour" onClick={this.toggleTenantDetails.bind(this)}>View all details</a>
                                :
                                    <a href="#" className="primary-colour" onClick={this.toggleTenantDetails.bind(this)}>Hide details</a>
                                }
                            </footer>
                        </section>
                    </div>

                    {lettingReferee && lettingReferee.type ?
                        <div id="lettingReferee" className="summary-widget" style={this.state.isLandlordDetailsVisible === true ? {width: '100%'} : null}>
                            <section className="pod">
                                <header className="header">
                                    <h3>Your {lettingRefereeTitle}</h3>
                                </header>
                                <div className="content">
                                    {lettingReferee.name ?
                                        <SummaryWidgetEntity
                                            fieldName="lettingRefereeName"
                                            localStorageChunk="BaseIndividualApplication.lettingReferee"
                                            localStorageKey="name"
                                            fieldType={'text'}
                                            label="Name"
                                            callbackFunction={this.forceTenantDetails.bind(this)}
                                        />
                                    : null}

                                    {lettingReferee.phone ?
                                        <SummaryWidgetEntity
                                            fieldName="lettingRefereePhone"
                                            localStorageChunk="BaseIndividualApplication.lettingReferee"
                                            localStorageKey="phone"
                                            fieldType={'text'}
                                            maxLength={11}
                                            label="Contact number"
                                            callbackFunction={this.forceTenantDetails.bind(this)}
                                        />
                                    : null}

                                    {lettingReferee.email ?
                                        <SummaryWidgetEntity
                                            fieldName="lettingRefereeEmail"
                                            localStorageChunk="BaseIndividualApplication.lettingReferee"
                                            localStorageKey="email"
                                            fieldType={'email'}
                                            label="Email"
                                            callbackFunction={this.forceTenantDetails.bind(this)}
                                        />
                                    : null}

                                    {this.state.isLandlordDetailsVisible === true ?
                                        <div>
                                            {lettingReferee.address ?
                                                <div className="summary-widget-row">
                                                    <strong>Address: </strong>
                                                    <span>
                                                        {lettingReferee.address.houseName ? lettingReferee.address.houseName + ', ' : null}
                                                        {lettingReferee.address.street ? lettingReferee.address.street + ', ' : null}
                                                        {lettingReferee.address.town ? lettingReferee.address.town + ', ' : null}
                                                        {lettingReferee.address.postcode ? lettingReferee.address.postcode : null}
                                                    </span>
                                                </div>
                                            : null}

                                            <h4>Rent Details</h4>
                                            {lettingRefereePaymentFrequency ?
                                                <SummaryWidgetEntity
                                                    fieldName="lettingRefereePaymentFrequency"
                                                    localStorageChunk="BaseIndividualApplication.lettingReferee"
                                                    localStorageKey="paymentFrequency"
                                                    fieldType={'select'}
                                                    label="Payment frequency"
                                                    callbackFunction={this.forceTenantDetails.bind(this)}
                                                    isInt={true}
                                                    options={[
                                                        {
                                                            option_value: Config.lettingRefereePaymentFrequencies.MONTHLY,
                                                            option_text: 'Monthly'
                                                        },
                                                        {
                                                            option_value: Config.lettingRefereePaymentFrequencies.FOUR_WEEKLY,
                                                            option_text: '4 weekly'
                                                        },
                                                        {
                                                            option_value: Config.lettingRefereePaymentFrequencies.WEEKLY,
                                                            option_text: 'Weekly'
                                                        },
                                                        {
                                                            option_value: Config.lettingRefereePaymentFrequencies.ALL_IN_ONE,
                                                            option_text: 'Full amount in advance'
                                                        },
                                                        {
                                                            option_value: Config.lettingRefereePaymentFrequencies.OTHER,
                                                            option_text: 'Other'
                                                        }
                                                    ]}
                                                />
                                            : null}

                                            {lettingReferee.paymentAmount ?
                                                <SummaryWidgetEntity
                                                    fieldName="lettingRefereePaymentAmount"
                                                    localStorageChunk="BaseIndividualApplication.lettingReferee"
                                                    localStorageKey="paymentAmount"
                                                    fieldType={'money'}
                                                    label="Payment amount"
                                                    labelPrefix={'£'}
                                                    callbackFunction={this.forceTenantDetails.bind(this)}
                                                />
                                            : null}

                                            {lettingReferee.paymentDayOfMonth ?
                                                <SummaryWidgetEntity
                                                    fieldName="lettingRefereePaymentDayOfMonth"
                                                    localStorageChunk="BaseIndividualApplication.lettingReferee"
                                                    localStorageKey="paymentDayOfMonth"
                                                    fieldType={'date'}
                                                    subType={'day'}
                                                    label="Payment day of month"
                                                    callbackFunction={this.forceTenantDetails.bind(this)}
                                                    isInt={true}
                                                />
                                            : null}

                                            {lettingReferee.paymentDayOfWeek ?
                                                <SummaryWidgetEntity
                                                    fieldName="lettingRefereePaymentDayOfWeek"
                                                    localStorageChunk="BaseIndividualApplication.lettingReferee"
                                                    localStorageKey="paymentDayOfWeek"
                                                    fieldType={'date'}
                                                    subType={'day-of-the-week'}
                                                    label="Payment day of the week"
                                                    callbackFunction={this.forceTenantDetails.bind(this)}
                                                    isInt={true}
                                                />
                                            : null}
                                        </div>
                                    : null}
                                </div>
                                <footer className="footer">
                                    {! this.state.isLandlordDetailsVisible ?
                                        <a href="#" className="primary-colour" onClick={this.toggleLandlordDetails.bind(this)}>View all details</a>
                                        :
                                        <a href="#" className="primary-colour" onClick={this.toggleLandlordDetails.bind(this)}>Hide details</a>
                                    }
                                </footer>
                            </section>
                        </div>
                    : null}

                    { financialReferees }

                    {Quote.getByPath('BaseIndividualApplication.hasAgreedToBankValidation') === true && !window.uorn(window.localStorage.getItem('BankValidationStrategy')) ?
                        <div className="summary-widget">
                            <section className="pod">
                                <header className="header">
                                    <h3>Bank Details</h3>
                                </header>
                                <div className="content">
                                    <SummaryWidgetEntity
                                        fieldName="bankValidationMethod"
                                        localStorageChunk="BankValidationStrategy.provider"
                                        localStorageKey="name"
                                        fieldType={'static'}
                                        isEditable={false}
                                        label="Bank Validation Method"
                                    />

                                    <SummaryWidgetEntity
                                        fieldName="optedIntoBankValidation"
                                        localStorageChunk="BaseIndividualApplication"
                                        localStorageKey="hasAgreedToBankValidation"
                                        fieldType={'static'}
                                        isEditable={false}
                                        hideValue={true}
                                        label="Opted in for bank data validation"
                                        statusType={'success'}
                                    />

                                    {Quote.getByPath('BankValidationStrategy.completedImmediately') === true ?
                                        <SummaryWidgetEntity
                                            fieldName="completedBankValidation"
                                            localStorageChunk="BaseIndividualApplication"
                                            localStorageKey="hasCompletedBankValidation"
                                            fieldType={'static'}
                                            isEditable={false}
                                            hideValue={true}
                                            label="Submitted details"
                                            statusType={Quote.getByPath('BaseIndividualApplication.hasCompletedBankValidation') === true ? 'success' : 'fail'}
                                        />
                                    :
                                        <SummaryWidgetEntity
                                            fieldName="completedBankValidation"
                                            localStorageChunk="BaseIndividualApplication"
                                            localStorageKey="hasCompletedBankValidation"
                                            fieldType={'static'}
                                            isEditable={false}
                                            hideValue={true}
                                            label="Submitted details"
                                            statusType={'pending'}
                                        />
                                    }
                                </div>
                            </section>
                        </div>
                    : null}
                </div>

                {
                    (tenant.canContactApplicantBySMSAndEmail === false && !window.uornorb(Quote.getByPath('domainInfo.canContactApplicantBySMSAndEmail'))) ||
                    (tenant.canContactApplicantByPhoneAndPost === false && !window.uornorb(Quote.getByPath('domainInfo.canContactApplicantByPhoneAndPost'))) ||
                    (tenant.canContactThirdPartyOptional === false && !window.uornorb(Quote.getByPath('domainInfo.canContactThirdPartyOptional'))) ||
                    (tenant.canContactThirdPartyMortgage === false && !window.uornorb(Quote.getByPath('domainInfo.canContactThirdPartyMortgage'))) ?
                    <div>
                        {!window.uorn(Quote.getByPath('domainInfo.remarketingMessage')) ?
                            <question-row class="header-row" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.remarketingMessage')}} />
                        : null}
                    </div>
                : null}

                {tenant.canContactApplicantBySMSAndEmail === false && !window.uornorb(Quote.getByPath('domainInfo.canContactApplicantBySMSAndEmail')) ?
                    <question-row class="header-row">
                        <div className="question-main">
                            <div className="question-input">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <div data-field="email2" className="card trigger" onClick={this.toggleCheckedState.bind(this, 'marketingPreferencesEmail')}>
                                            <img src="/images/SMS-and-Email.svg" className="marketing-selection-icon" />
                                            <CheckboxInput
                                                fieldName="marketingPreferencesEmail"
                                                question="SMS & Email"
                                                isLabelFirst={true}
                                                isDefaultChecked={Quote.getByPath('BaseIndividualApplication.canContactApplicantBySMSAndEmail')}
                                                source={'BaseIndividualApplication'}
                                                storageKey={'canContactApplicantBySMSAndEmail'}
                                            />
                                        </div>
                                    </div>

                                    <div className="column" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.canContactApplicantBySMSAndEmail')}} />
                                </div>
                            </div>
                        </div>
                    </question-row>
                : null}

                {tenant.canContactApplicantByPhoneAndPost === false && !window.uornorb(Quote.getByPath('domainInfo.canContactApplicantByPhoneAndPost')) ?
                    <question-row class="header-row">
                        <div className="question-main">
                            <div className="question-input">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <div data-field="phone2" className="card trigger" onClick={this.toggleCheckedState.bind(this, 'marketingPreferencesTelephone')}>
                                            <img src="/images/Phone-and-Post.svg" className="marketing-selection-icon" />
                                            <CheckboxInput
                                                fieldName="marketingPreferencesTelephone"
                                                question="Telephone & Post"
                                                isLabelFirst={true}
                                                isDefaultChecked={Quote.getByPath('BaseIndividualApplication.canContactApplicantByPhoneAndPost')}
                                                source={'BaseIndividualApplication'}
                                                storageKey={'canContactApplicantByPhoneAndPost'}
                                            />
                                        </div>
                                    </div>

                                    <div className="column" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.canContactApplicantByPhoneAndPost')}} />
                                </div>
                            </div>
                        </div>
                    </question-row>
                : null}

                {tenant.canContactThirdPartyOptional === false && !window.uornorb(Quote.getByPath('domainInfo.canContactThirdPartyOptional')) ?
                    <question-row class="header-row">
                        <div className="question-main">
                            <div className="question-input">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <div data-field="thirdparty2" className="card trigger" onClick={this.toggleCheckedState.bind(this, 'marketingPreferencesThirdParty')}>
                                            <CheckboxInput
                                                fieldName="marketingPreferencesThirdParty"
                                                question="I agree"
                                                isLabelFirst={true}
                                                isDefaultChecked={Quote.getByPath('BaseIndividualApplication.canContactThirdPartyOptional')}
                                                source={'BaseIndividualApplication'}
                                                storageKey={'canContactThirdPartyOptional'}
                                            />
                                        </div>
                                    </div>

                                    <div className="column" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.canContactThirdPartyOptional')}} />
                                </div>
                            </div>
                        </div>
                    </question-row>
                : null}

                {tenant.canContactThirdPartyMortgage === false && !window.uornorb(Quote.getByPath('domainInfo.canContactThirdPartyMortgage')) ?
                    <question-row class="header-row">
                        <div className="question-main">
                            <div className="question-input">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <div data-field="mortgage2" className="card trigger" onClick={this.toggleCheckedState.bind(this, 'canContactThirdPartyMortgage')}>
                                            <CheckboxInput
                                                fieldName="canContactThirdPartyMortgage"
                                                question="I agree"
                                                isLabelFirst={true}
                                                isDefaultChecked={Quote.getByPath('BaseIndividualApplication.canContactThirdPartyMortgage')}
                                                source={'BaseIndividualApplication'}
                                                storageKey={'canContactThirdPartyMortgage'}
                                            />
                                        </div>
                                    </div>

                                    <div className="column" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.canContactThirdPartyMortgage')}} />
                                </div>
                            </div>
                        </div>
                    </question-row>
                : null}

                <div className={this.state.isPhonePostModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                    <div className="modal">
                        <div className="modal-header">
                            Don't Miss Out
                            <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                <FaCross className="pointer" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="content">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <img src="/images/Phone-and-Post.svg" className="marketing-selection-icon" />
                                        <div data-field="phone2">
                                            <CheckboxInput
                                                fieldName="marketingPreferencesTelephone"
                                                storageKey="canContactApplicantByPhoneAndPost"
                                                source="BaseIndividualApplication"
                                                question="Phone & Post"
                                                isDefaultChecked={isPhoneAndPostChecked}
                                            />
                                        </div>
                                    </div>

                                    <div className="column">
                                        <p>We&rsquo;re experts in products and services for tenants. We won&rsquo;t share your personal data with anyone else for marketing purposes, so the only offers you&rsquo;ll get will be from us. If you&rsquo;d prefer that we didn&rsquo;t contact you with any further information by phone and post, please untick the box.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <ButtonInput
                                id="acceptTerms"
                                buttonText="CLOSE"
                                classNames="btn-default"
                                onClickEvent={this.closeModals.bind(this)}
                            />
                        </div>
                    </div>
                </div>

                <SaveForLaterModal
                    ref="SaveForLaterModal"
                />

                <SubmitInput
                    label="Submit for referencing"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    saveForLater={false}
                    saveForLaterFunc={() => {
                        HttpService.applicationPutApplication(() => {
                            this.refs.SaveForLaterModal.toggleIsActive();
                        }, (invalidData) => {
                            window.localStorage.setItem('validationError', JSON.stringify(invalidData));
                            browserHistory.push('/error/applicant-validation');
                        });
                    }}
                    currentNumber={6}
                />
            </div>
        );
    }
}

Summary.propTypes = {
    params: PropTypes.object,
};

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Screens/Summary.js